import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

const navToggle = document.querySelector(".nav-toggle")
const primaryNav = document.querySelector(".primary-nav")
const navDropdowns = document.querySelectorAll(".nav-dropdown")

navDropdowns.forEach(dropdown => {
  document.addEventListener("click", event => {
    if (!dropdown.contains(event.target)) dropdown.open = false
  })

  dropdown.addEventListener("keydown", event => {
    if (event.key === "Escape" && dropdown.open) {
      event.preventDefault()
      dropdown.open = false
      dropdown.querySelector("summary").focus()
    }
  })

  dropdown.addEventListener("focusout", event => {
    if (!dropdown.contains(event.relatedTarget)) dropdown.open = false
  })
})

if (navToggle && primaryNav) {
  navToggle.addEventListener("click", () => {
    const isOpen = navToggle.getAttribute("aria-expanded") === "true"
    navToggle.setAttribute("aria-expanded", String(!isOpen))
    primaryNav.dataset.open = String(!isOpen)
    if (isOpen) navDropdowns.forEach(dropdown => { dropdown.open = false })
  })

  primaryNav.querySelectorAll("a").forEach(link => {
    link.addEventListener("click", () => {
      navToggle.setAttribute("aria-expanded", "false")
      primaryNav.dataset.open = "false"
      navDropdowns.forEach(dropdown => { dropdown.open = false })
    })
  })
}

const waitlistForm = document.querySelector("[data-waitlist-form]")

if (waitlistForm?.dataset.connected === "false") {
  waitlistForm.addEventListener("submit", event => {
    event.preventDefault()
    const status = waitlistForm.querySelector("[data-form-status]")

    if (status) {
      status.dataset.state = "error"
      status.textContent = "Email signup is not connected yet. Add the form endpoint before publishing."
    }
  })
}
